/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

const ProjectDetails = ({ item }) => {
  return (
    <div className="projects" data-aos="fade-up">
      <div className="project-description">
        <h5>0{item?.index}</h5>
        <div className="projectsImg">
          <h1>{item?.name}</h1>
          <h4>{item.title}</h4>
          <h6>{item?.description}</h6>
          <div className="docs Your IT Shop - Website Link | Front-end Code | Back-end Code">
            <h5>
              <a href={`${item?.githubLink}`}>Github</a>
            </h5>
            <h5>
              <a href={`${item?.live}`}>live</a>
            </h5>
          </div>
        </div>
      </div>
      <div className="project-img">
        <img src={item.image} alt="" />
      </div>
    </div>
  );
};

export default ProjectDetails;
